﻿import { IHashData } from "./IHashData";

export class HashDataManager {

    public encode(data: IHashData): string {
        return "#" + $.param(data);
    }

    public decode(hash: string): IHashData {

        if (hash.length != 0 && hash.charAt(0) == '#') {
            hash = hash.substr(1);
        }

        return $.deparam(hash);
    }
}